import axios from 'axios';
import { API } from '../../config/api';
import { basicAuth } from '../../config/auth';

// Onno component er action type/state er sathe conflict na hoy tai completely
// alada namespace e prefix kora holo (HEADER_SEARCH_)
export const HEADER_SEARCH_FETCH_REQUEST = 'HEADER_SEARCH_FETCH_REQUEST';
export const HEADER_SEARCH_FETCH_SUCCESS = 'HEADER_SEARCH_FETCH_SUCCESS';
export const HEADER_SEARCH_FETCH_FAILURE = 'HEADER_SEARCH_FETCH_FAILURE';
export const HEADER_SEARCH_CLEAR = 'HEADER_SEARCH_CLEAR';

export const headerSearchFetchRequest = () => ({ type: HEADER_SEARCH_FETCH_REQUEST });
export const headerSearchFetchSuccess = (data) => ({ type: HEADER_SEARCH_FETCH_SUCCESS, payload: data });
export const headerSearchFetchFailure = (error) => ({ type: HEADER_SEARCH_FETCH_FAILURE, payload: error });

// Module-level cancel token source, purely এই header search flow er jonno.
// Onno kono component er axios call er sathe eta share hoy na.
let headerSearchCancelSource;

export const fetchHeaderSearchUsers = (params = {}) => {
  return async (dispatch) => {
    if (headerSearchCancelSource) {
      headerSearchCancelSource.cancel('New header search initiated');
    }
    headerSearchCancelSource = axios.CancelToken.source();

    dispatch(headerSearchFetchRequest());
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axios.get(`${API.auth.user}${queryString ? `?${queryString}` : ''}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Basic ${basicAuth}`,
        },
        cancelToken: headerSearchCancelSource.token,
      });

      dispatch(headerSearchFetchSuccess(response.data.users));
    } catch (error) {
      if (axios.isCancel(error)) {
        return;
      }
      console.error('Error fetching header search users:', error);
      dispatch(headerSearchFetchFailure(error.message));
    }
  };
};

export const clearHeaderSearchUsers = () => {
  if (headerSearchCancelSource) {
    headerSearchCancelSource.cancel('Header search cleared');
  }
  return { type: HEADER_SEARCH_CLEAR };
};